module.exports = __webpack_public_path__ + "38ce5b6b2bc672ddc685247f8733ae30.png";